/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import ReactPlayer from "react-player"

import { ab } from "../theme"

const Video = ({ video, children, reverse }) => (
  <div
    sx={{
      variant: "spacingContainer",
    }}
  >
    <div
      sx={{
        display: ab({ md: "flex" }),
        flexDirection: reverse ? "row-reverse" : "row",
        color: "text",
      }}
    >
      <div
        sx={{
          flex: 1,
          my: 0,
          py: ab({ md: 3 }),
          paddingRight: ab({ md: reverse ? 0 : 4 }),
          paddingLeft: ab({ md: reverse ? 4 : 0 }),
        }}
      >
        <ReactPlayer url={video} width="100%" controls={true} />
      </div>
      <div
        sx={{
          flex: 1,
          my: 0,
        }}
      >
        {children}
      </div>
    </div>
  </div>
)

Video.propTypes = {
  video: PropTypes.string.isRequired,
  children: PropTypes.node,
  reverse: PropTypes.bool,
}

export default Video
